import { observer } from "mobx-react-lite";

import contentStore from "../stores/cms/contentStore";

import AlertMessage from "./AlertMessage";

const TopBarWarnings = () => {
   const warnings = contentStore.getCurrentWarnings();

   const filteredWarnings = warnings.filter((c) => c.warningtype?.includes("Toppen av alle sider"));

   if (filteredWarnings.length === 0) {
      return null;
   }
   return (
      <aside className="print:hidden">
         {filteredWarnings.map((warning) => (
            <AlertMessage key={warning.internalName} warning={warning} className="md:[&>div]:px-12" />
         ))}
      </aside>
   );
};

export default observer(TopBarWarnings);
